const getAssignerTasksAPI = (branchId = 0, startDate, endDate, timezoneOffset) =>
  `api/tasks/assigned?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const createNewTaskAPI = () => 'api/tasks';

const closeTaskAPI = (taskId) => `api/tasks/actions/close/${taskId}`;

const readTaskAPI = (taskId) => `api/tasks/read/${taskId}`;

const approveCompletedAPI = (taskId) => `api/tasks/actions/approve-completed/${taskId}`;

const rejectCompletedAPI = (taskId) => `api/tasks/actions/reject-completed/${taskId}`;

const approveNewDeadlineAPI = (taskId) => `api/tasks/actions/approve-new-deadline/${taskId}`;

const declineNewDeadlineAPI = (taskId) => `api/tasks/actions/decline-new-deadline/${taskId}`;

const getReceiverTasksAPI = (branchId = 0, startDate, endDate, timezoneOffset) =>
  `api/tasks/received?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const proposeNewDeadlineAPI = (taskId) => `api/tasks/actions/propose-new-deadline/${taskId}`;

const cancelNewDeadlineAPI = (taskId) => `api/tasks/actions/cancel-new-deadline/${taskId}`;

const markAsCompletedAPI = (taskId) => `api/tasks/actions/mark-as-completed/${taskId}`;

const acknowledgeUncompletedAPI = (taskId) => `api/tasks/actions/acknowledge-uncompleted/${taskId}`;

export const taskManagementEndpoints = {
  getAssignerTasksAPI,
  createNewTaskAPI,
  closeTaskAPI,
  approveCompletedAPI,
  rejectCompletedAPI,
  approveNewDeadlineAPI,
  declineNewDeadlineAPI,
  getReceiverTasksAPI,
  proposeNewDeadlineAPI,
  cancelNewDeadlineAPI,
  markAsCompletedAPI,
  acknowledgeUncompletedAPI,
  readTaskAPI,
};
